export const UTILITIES = {
  ELECTRICITY: "electricity",
  HEATING: "heating",
  AIR_CONDITIONING: "airConditioning",
  WATER: "water",
  GARBAGE_REMOVAL: "garbageRemoval",
  CABLE_TV: "cableTv",
  INTERNET: "internet",
  MAINTENANCE_FEES: "maintenanceFees",
  GAS: "gas"
}

export const Utilities = [
  { name: "Electricity", value: UTILITIES.ELECTRICITY, icon: "/images/hydro.svg" },
  { name: "Heating", value: UTILITIES.HEATING, icon: "/images/heating.svg" },
  { name: "AC", value: UTILITIES.AIR_CONDITIONING, icon: "/images/ac.svg" },
  { name: "Water", value: UTILITIES.WATER, icon: "/images/water.svg" },
  {
    name: "Garbage Removal",
    value: UTILITIES.GARBAGE_REMOVAL,
    icon: "/images/garbage_removal.svg"
  },
  { name: "Cable TV", value: UTILITIES.CABLE_TV, icon: "/images/cable.svg" },
  { name: "Internet", value: UTILITIES.INTERNET, icon: "/images/wi-fi.svg" },
  {
    name: "Maintenance Fees",
    value: UTILITIES.MAINTENANCE_FEES,
    icon: "/images/maintenance_fees.svg"
  },
  {
    name: "Gas",
    value: UTILITIES.GAS,
    icon: "/images/gas.png"
  }
]
